import { render, staticRenderFns } from "./formbuilderAutomationLogs.vue?vue&type=template&id=71fb0417&scoped=true"
import script from "./formbuilderAutomationLogs.vue?vue&type=script&lang=js"
export * from "./formbuilderAutomationLogs.vue?vue&type=script&lang=js"
import style0 from "./formbuilderAutomationLogs.vue?vue&type=style&index=0&id=71fb0417&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fb0417",
  null
  
)

export default component.exports